import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const PageTitle = styled.h1`
    ${FONTS.H1};
    color: ${COLORS.TextPrimary};
    margin-top: 0;
    margin-bottom: 32px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-bottom: 24px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H3};
    }
`;

export const PageContent = styled.div`
    display: grid;
    grid-template-columns: 480px 992px;
    column-gap: 32px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        grid-template-columns: 384px 800px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        grid-template-columns: 296px 616px;
        column-gap: 24px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        grid-template-columns: 1fr;
        row-gap: 32px;
    }
`;

export const InfoBlock = styled.div`
    flex-direction: column;
    width: 100%;
    row-gap: 24px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-top: 8px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-top: 0;
    }
`;

export const ActionsBlock = styled.div`
    flex-direction: column;
    width: 100%;
    row-gap: 64px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 100%;
        row-gap: 32px;
    }
`;

export const ActionSectionWrapper = styled.div`
    flex-direction: column;
    width: 100%;
    row-gap: 24px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        align-items: initial;
        row-gap: 16px;
    }
`;

export const ActionSectionTitle = styled.h3`
    ${FONTS.H3};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H4};
    }
`;

export const ActionSectionContent = styled.div`
    flex-direction: column;
    width: 100%;
    align-items: baseline;
    row-gap: 24px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        align-items: initial;
        row-gap: 32px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        row-gap: 12px;
    }
`;

export const Container = styled.div`
    flex-direction: column;
    width: 100%;
    ${FONTS.S};
`;

export const HeaderText = styled.p`
    ${FONTS.S};
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const Header = styled.h2<{margin: string}>`
    ${FONTS.H3};
    margin-bottom: ${props => props.margin};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const Link = styled.a`
    ${FONTS.S};
    color: ${COLORS.Link};
    cursor: pointer;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};
    }
`;
